import { ISnackbarPrompt } from './types';
import { Dispatch } from '../../../../../types/actions';
import { SnackbarVariant } from '../../store/types';
import { SNACKBAR_BUTTON_CANCEL, SNACKBAR_BUTTON_OK } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';

export const snackbarPromtDefault = (
    options: ISnackbarPrompt,
) => {
    return (dispatch: Dispatch) => {
        const shouldUseControlsDefault = options.buttons === undefined;
        if (shouldUseControlsDefault) {
            options.buttons = [
                {
                    onClick: () => dispatch(getDefaultActionEvent(options.id, options.actionCancel)),
                    text: SNACKBAR_BUTTON_CANCEL
                },
                {
                    onClick: () => dispatch(getDefaultActionEvent(options.id, options.actionApply)),
                    isPrimary: true,
                    text: SNACKBAR_BUTTON_OK
                },
            ];
        }
        dispatch(addUpdateSnackbarWithBubble({
            ...options,
            variant: SnackbarVariant.PROMT,
        }));
    }
};
